import { Guid, IBaseModel, Code } from '~/interfaces/base'
import emptyId from '~/statics/empty-id'

export class JobCode implements IBaseModel {
  id: Guid
  code: Code
  name: string

  constructor() {
    this.id = emptyId
    this.code = ''
    this.name = ''
  }
}